import { Ellipsis, Title, desktopFirstMediaQuery } from '@inflearn/ds-react-next';

export function UserName({ name }: { name: string }) {
  return (
    <Ellipsis lineClamp={1}>
      <Title
        order={2}
        c="dark.9"
        fw="default"
        size="h1"
        maw={650}
        styles={{
          root: {
            [desktopFirstMediaQuery.mobile]: {
              fontSize: 'var(--mantine-h2-font-size)',
              lineHeight: 'var(--mantine-h2-line-height)',
            },
          },
        }}
      >
        {name}
      </Title>
    </Ellipsis>
  );
}
